<template>
	<div v-show="show">
		<vx-card id="company-card-main">
			<div slot="no-body" class="tabs-container px-6 pt-6" v-if="roleCreatePermission">
				<div class="content">
					<RoleForm :editable="false" />
				</div>
			</div>

			<not-permission v-else></not-permission>
		</vx-card>
	</div>
</template>

<script>
import RoleForm from "../../components/role/RoleForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "CreateRole",
	components: {
		RoleForm,
		NotPermission,
	},
	data() {
		return {
			show: false,
		};
	},
	computed: {
		roleCreatePermission() {
			return this.$store.getters.checkPermission("ROLE_C");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>

<style>
.content {
	overflow: hidden;
}
</style>
